import { defineStore } from '#imports';

enum messageType {
  success = 'success',
  error = 'error',
}

type messageTypeString = keyof typeof messageType

interface NotificationPayloadInterface {
  messageText: string;
  messageType: string | messageTypeString;
}

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    notification: {
      messageText: '',
      messageType: '',
    },
  }),
  getters: {
    getNotification() : NotificationPayloadInterface {
      return this.notification;
    }
  },
  actions: {
    setNotification({ messageText, messageType } : NotificationPayloadInterface) {
      this.notification = {
        messageText,
        messageType
      }
    },
    clearNotification() {
      this.setNotification({
        messageText: '',
        messageType: '',
      })
    }
  }
});
